import { getUserMenuOptionsFromToken } from "../utils/Auth";
import { MenuAccess } from "../utils/menuOptions";

export const hasAccess = (accessType: MenuAccess): boolean => {
	const menuOptions = getUserMenuOptionsFromToken();
	return menuOptions?.includes(accessType) ?? false;
};
